<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!template"
            :item="template"
            @success="alertSuccess($event)"
            @delete-item="deleteType"
            @cancel="template = null"
        ></view-item>

        <list-items
            v-else
            title="Templates"
            @show-item="showTemplate"
            ref="table"
        >
            <b-row v-if="user_permissions.includes('create.order.templates')">
                <b-col offset="8" class="text-right">
                    <b-button size="sm" variant="primary" @click="template = {}"
                        >Add Template</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'OrderTemplate',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            template: null,
        }
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orderCategory/fetchAll')
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        types() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('orderTemplate/fetchAll')
        },

        showTemplate(id) {
            this.template = this.templates.find(x => x.id === id)
        },

        alertSuccess(message) {
            this.doToast('Success', message, 'success')
            this.template = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
